//<editor-fold desc="Main Actions">
export const TOGGLE_APP_DRAWER = 'TOGGLE_APP_DRAWER'
export const SET_DRAWER_STATE = 'SET_DRAWER_STATE'
export const FETCH_TAGS = 'FETCH_TAGS'
export const FETCH_TAG_BY_ID = 'FETCH_TAG_BY_ID'
export const SAVE_NEW_TAG = 'SAVE_NEW_TAG'
export const UPDATE_TAG = 'UPDATE_TAG'
export const DELETE_SELECTED_TAG = 'DELETE_SELECTED_TAG'

//</editor-fold>

//<editor-fold desc="Auth Module Actions">
export const AUTH_LOG_USER_IN = 'LOG_USER_IN'
export const AUTH_LOG_USER_OUT = 'LOG_USER_OUT'
export const AUTH_LOG_USER_IN_WITH_TOKEN = 'AUTH_LOG_USER_IN_WITH_TOKEN'
export const INIT_STORE = 'INIT_STORE'
export const AUTH_INIT_MODULE = 'AUTH_INIT_MODULE'
export const SET_INVALID_TOKEN = 'SET_INVALID_TOKEN'
//</editor-fold>

//<editor-fold desc="Customer Module Actions">
export const CUSTOMER_FETCH_CUSTOMER_LIST = 'CUSTOMER_FETCH_CUSTOMER_LIST'
//</editor-fold>

//<editor-fold desc="Boarder Module Actions">
export const BOARDER_FETCH_BOARDER_GROUP_LIST = 'BOARDER_FETCH_BOARDER_GROUP_LIST'
export const BOARDER_FETCH_BOARDER_GROUP_LIST_AS_INTERFACE = 'BOARDER_FETCH_BOARDER_GROUP_LIST_AS_INTERFACE'
export const BOARDER_UPDATE_BOARDER_GROUP = 'BOARDER_UPDATE_BOARDER_GROUP'
export const BOARDER_FETCH_LIST = 'BOARDER_FETCH_LIST'
export const BOARDER_FETCH_CALENDAR = 'BOARDER_FETCH_CALENDAR'
export const BOARDER_ARCHIVE = 'BOARDER_ARCHIVE'
export const BOARDER_MOVE_TO_GROUP = 'BOARDER_MOVE_TO_GROUP'
export const BOARDER_CREATE = 'BOARDER_CREATE'
export const BOARDER_DOWNLOAD_QR_FILE = 'BOARDER_DOWNLOAD_QR_FILE'
//</editor-fold>

//DAILY MENU
export const AVAILABLE_DAILY_MENU = 'AVAILABLE_DAILY_MENU'
export const SWITCH_DAILYMENU = 'SWITCH_DAILYMENU'
/** @deprecated */
export const SAVE_FODD_TO_DAILYMENU = 'SAVE_FODD_TO_DAILYMENU'
export const SET_SELECTED_DAILYMENU_VIEW = 'SET_SELECTED_DAILYMENU_VIEW'
export const SEARCH_FOOD_ITEM = 'SEARCH_FOOD_ITEM'
export const FETCH_DAILY_MENU = 'FETCH_DAILY_MENU'
export const UPDATE_SLOT = 'UPDATE_SLOT'
export const PLACE_NEW_RESERVATION = 'PLACE_NEW_RESERVATION'
export const CHANGE_EXISTING_RESERVATION = 'CHANGE_EXISTING_RESERVATION'
export const CHANGE_EXISTING_RESERVATION_STATUS = 'CHANGE_EXISTING_RESERVATION_STATUS'
export const CANCEL_EXISTING_RESERVATION = 'CANCEL_EXISTING_RESERVATION'
export const RESTORE_EXISTING_RESERVATION = 'RESTORE_EXISTING_RESERVATION'
export const FETCH_FOOD_ITEM_DETAILS = 'FETCH_FOOD_ITEM_DETAILS'

//RESERVATION PAGE
export const AVAILABLE_RESERVATION = 'AVAILABLE_RESERVATION'
export const FETCH_OPT_OUT_VERIFICATION = 'FETCH_OPT_OUT_VERIFICATION'
export const PERFORM_BATCH_RESERVATION_OPT_OUT = 'PERFORM_BATCH_RESERVATION_OPT_OUT'
export const FETCH_OPT_IN_VERIFICATION = 'FETCH_OPT_IN_VERIFICATION'
export const PERFORM_BATCH_RESERVATION_OPT_IN = 'PERFORM_BATCH_RESERVATION_OPT_IN'

//<editor-fold desc="Reporting Module Actions">
export const REPORTING_FETCH_RESERVATION_BY_DAY = 'REPORTING_FETCH_RESERVATION_BY_DAY'
//</editor-fold>

//<editor-fold desc="Food Database Module Actions">
export const FOOD_DATABASE_FETCH_FOOD_ITEMS = 'FOOD_DATABASE_FETCH_FOOD_ITEMS'
export const FOOD_DATABASE_CREATE_FOOD_ITEM = 'FOOD_DATABASE_CREATE_FOOD_ITEM'
export const FOOD_DATABASE_UPDATE_FOOD_ITEM = 'FOOD_DATABASE_UPDATE_FOOD_ITEM'
//</editor-fold>

export const FETCH_PERSON_CREDENTIAL_BY_ID = 'FETCH_PERSON_CREDENTIAL_BY_ID'
export const UPDATE_PERSON_CREDENTIAL_PASS_BY_ID = 'UPDATE_PERSON_CREDENTIAL_PASS_BY_ID'
export const UPDATE_PERSON_CREDENTIAL_PASS = 'UPDATE_PERSON_CREDENTIAL_PASS'

export const FETCH_ALGORITHM_LIST = 'FETCH_ALGORITHM_LIST'
export const USER_DAILY_MENU = 'USER_DAILY_MENU'
export const USER_SETTINGS_4_ORDERING = 'USER_SETTINGS_4_ORDERING'
/** @deprecated Use pinia instead */
export const FETCH_BUSINESS_DATA = 'FETCH_BUSINESS_DATA'
export const FETCH_GROUP_DATA = 'FETCH_GROUP_DATA'

export const SHOW_RESPONSE_ERROR_DIALOG = 'SHOW_RESPONSE_ERROR_DIALOG'
export const HIDE_RESPONSE_ERROR_DIALOG = 'HIDE_RESPONSE_ERROR_DIALOG'

export const STORNO_DAILYMENU = 'STORNO_DAILYMENU'
export const SAVE_DAILYMENU = 'SAVE_DAILYMENU'
export const SAVE_RESTORE_DAILYMENU = 'SAVE_RESTORE_DAILYMENU'
export const FETCH_OFFER_RESERVATION = 'FETCH_OFFER_RESERVATION'

export const FETCH_MY_LATEST_INVOICES = 'FETCH_MY_LATEST_INVOICES'
export const DOWNLOAD_INVOICE = 'DOWNLOAD_INVOICE'

export const FETCH_POSTAL_ADDRESS = 'FETCH_POSTAL_ADDRESS'
export const FETCH_BANK_ACCOUNT = 'FETCH_BANK_ACCOUNT'
export const CREATE_POSTAL_ADDRESS = 'CREATE_POSTAL_ADDRESS'
export const CREATE_BANK_ACCOUNT = 'CREATE_BANK_ACCOUNT'
export const UPDATE_POSTAL_ADDRESS = 'UPDATE_POSTAL_ADDRESS'
export const UPDATE_BANK_ACCOUNT = 'UPDATE_BANK_ACCOUNT'
export const FETCH_TENANT_NAME = 'FETCH_TENANT_NAME'
export const CREATE_TENANT_NAME = 'CREATE_TENANT_NAME'
export const UPDATE_TENANT_NAME = 'UPDATE_TENANT_NAME'

export const FETCH_CALENDAR_EVENTS_LIST = 'FETCH_CALENDAR_EVENTS_LIST'
export const FETCH_CALENDAR_EVENTS_FOR_DAY = 'FETCH_CALENDAR_EVENTS_FOR_DAY'
export const FETCH_NUMBER_OF_ORDERS = 'FETCH_NUMBER_OF_ORDERS'
export const CREATE_CALENDAR_EVENT_FOR_DAY = 'CREATE_CALENDAR_EVENT_FOR_DAY'
export const DELETE_CALENDAR_EVENT_FOR_DAY = 'DELETE_CALENDAR_EVENT_FOR_DAY'

export const FETCH_CREDIT_HISTORY = 'FETCH_CREDIT_HISTORY'
export const INSERT_CREDIT_OPERATION = 'INSERT_CREDIT_OPERATION'
export const ADMIN_DELIVER_FOOD = 'ADMIN_DELIVER_FOOD'

export const FETCH_BILLINGS = 'FETCH_BILLINGS'
export const CREATE_NEW_BILLING = 'CREATE_NEW_BILLING'
export const DELETE_BILLING = 'DELETE_BILLING'
export const FETCH_INVOICE = 'FETCH_INVOICE'

export const FETCH_BANK_TRANSACTION_LIST = 'FETCH_BANK_TRANSACTION_LIST'
export const CREATE_NEW_TRANSACTION = 'CREATE_NEW_TRANSACTION'
export const FETCH_BANK_TRANSACTION_DETAIL = 'FETCH_BANK_TRANSACTION_DETAIL'
export const UPLOAD_TRANSACTION = 'UPLOAD_TRANSACTION'
export const RESOLVE_TRANSACTION = 'RESOLVE_TRANSACTION'

export const FETCH_BOARDER_DETAIL = 'FETCH_BOARDER_DETAIL'
export const UPDATE_BOARDER_DETAIL = 'UPDATE_BOARDER_DETAIL'
export const FETCH_BOARDER_SETTINGS = 'FETCH_BOARDER_SETTINGS'
export const UPDATE_BOARDER_SETTINGS = 'UPDATE_BOARDER_SETTINGS'

export const FETCH_DEBTORS = 'FETCH_DEBTORS'
export const FETCH_DEBTOR_DETAIL = 'FETCH_DEBTOR_DETAIL'

export const FETCH_MESSAGE_TEMPLATE_LIST = 'FETCH_MESSAGE_TEMPLATE_LIST'
export const SAVE_NEW_MESSAGE_TEMPLATE = 'SAVE_NEW_MESSAGE_TEMPLATE'
export const DELETE_MESSAGE_TEMPLATE = 'DELETE_MESSAGE_TEMPLATE'
export const UPDATE_MESSAGE_TEMPLATE = 'UPDATE_MESSAGE_TEMPLATE'
export const SEND_NEW_MESSAGE = 'SEND_NEW_MESSAGE'
export const SAVE_NEW_GROUP = 'SAVE_NEW_GROUP'
export const FETCH_MENU_GROUP_DATA = 'FETCH_MENU_GROUP_DATA'
export const SAVE_UPDATED_GROUP = 'SAVE_UPDATED_GROUP'
export const CREATE_NEW_SLOT = 'CREATE_NEW_SLOT'
export const UPDATE_SLOT_ORDER = 'UPDATE_SLOT_ORDER'

export const FETCH_ALLERGEN_LIST = 'FETCH_ALLERGEN_LIST'

export const SAVE_NEW_KEY = 'SAVE_NEW_KEY'
export const GET_API_KEY = 'GET_API_KEY'
export const DELETE_KEY = 'DELETE_KEY'
export const SAVE_NEW_BUSINESS = 'SAVE_NEW_BUSINESS'
export const UPDATE_BUSINESS = 'UPDATE_BUSINESS'

/** @deprecated Use pinia instead */
export const FETCH_TIME_BLOCK_COLLECTION = 'FETCH_TIME_BLOCK_COLLECTION'
export const SAVE_NEW_TIME_BLOCK = 'SAVE_NEW_TIME_BLOCK'
export const DELETE_NEW_TIME_BLOCK = 'DELETE_NEW_TIME_BLOCK'
export const UPDATE_TIME_BLOCK = 'UPDATE_TIME_BLOCK'
export const FETCH_TIME_BLOCK_COLLECTION_BY_ID = 'FETCH_TIME_BLOCK_COLLECTION_BY_ID'

export const GET_KEY = 'GET_KEY'
export const SAVE_NEW_SETTING= 'SAVE_NEW_SETTING'
export const SAVE_SETTINGS = 'SAVE_SETTINGS'
export const GET_SETTING_DATA = 'GET_SETTING_DATA'
export const FETCH_SETTINGS_KEY = 'FETCH_SETTINGS_KEY'
export const FETCH_KEY_BY_ID = 'FETCH_KEY_BY_ID'

export const CREATE_NEW_CONFIGURATION_SETTINGS = 'CREATE_NEW_CONFIGURATION_SETTINGS'
export const UPDATE_NEW_CONFIGURATION_SETTINGS = 'UPDATE_NEW_CONFIGURATION_SETTINGS'

export const DELETE_SELECTED_CONFIGURATION = 'DELETE_SELECTED_CONFIGURATION'

export const FETCH_ARCHIVED_BOARDER_LIST = 'FETCH_ARCHIVED_BOARDER_LIST'
export const REMOVE_BOARDER_FROM_ARCHIVE = 'REMOVE_BOARDER_FROM_ARCHIVE'
export const UPDATE_ACCOUNT_USER = 'UPDATE_ACCOUNT_USER'
export const UPDATE_ACCOUNT_EMAILS = 'UPDATE_ACCOUNT_EMAILS'
export const FETCH_ACCOUNT_USER = 'FETCH_ACCOUNT_USER'
export const FETCH_ACCOUNT_EMAILS = 'FETCH_ACCOUNT_EMAILS'
export const SAVE_NEW_FOODITEM_IMAGE = 'SAVE_NEW_FOODITEM_IMAGE'
export const FETCH_FOOD_ITEM_IMAGES = 'FETCH_FOOD_ITEM_IMAGES'
export const DELETE_FOOD_ITEM_IMAGE = 'DELETE_FOOD_ITEM_IMAGE'
export const UPDATE_FOOD_ITEM_IMAGE = 'UPDATE_FOOD_ITEM_IMAGE'
export const SWITCH_APPLICATION_LANGUAGE = 'SWITCH_APPLICATION_LANGUAGE'

export const FETCH_REQUESTLIST = 'FETCH_REQUESTLIST'
export const ACCEPTED_REQUEST = 'ACCEPTED_REQUEST'
export const FETCH_LATEST_RESERVATIONS = 'FETCH_LATEST_RESERVATIONS'
export const FETCH_BOARDER_DETAIL_WITH_CANCEL = 'FETCH_BOARDER_DETAIL_WITH_CANCEL'

export const FETCH_CUSTOMER_BY_ID = 'FETCH_CUSTOMER_BY_ID'
export const FETCH_SMARTLINKS = 'FETCH_SMARTLINKS'
export const FETCH_LANDING_PAGE_CONFIG = 'FETCH_LANDING_PAGE_CONFIG'
export const UPDATE_LANDING_PAGE_CONFIG = 'UPDATE_LANDING_PAGE_CONFIG'

export const FETCH_REQUEST_KIND_LIST = 'FETCH_REQUEST_KIND_LIST'
export const UPDATE_SELECTED_SMART_LINK = 'UPDATE_SELECTED_SMART_LINK'
export const CREATE_NEW_SMART_LINK = 'CREATE_NEW_SMART_LINK'
export const FETCH_ACTION_KIND_LIST = 'FETCH_ACTION_KIND_LIST'
export const SEARCH_SMART_LINK = 'SEARCH_SMART_LINK'
export const FETCH_BOARDER_QRCODE = 'FETCH_BOARDER_QRCODE'

export const SET_SMART_LINK_FILTER = 'SET_SMART_LINK_FILTER'

export const DELETE_SELECTED_SMART_LINK = 'DELETE_SELECTED_SMART_LINK'
export const PRINT_SELECTED_SMART_LINK = 'PRINT_SELECTED_SMART_LINK'
export const FETCH_STATISTICS = 'FETCH_STATISTICS'

export const FETCH_CUSTOMER_DATA = 'FETCH_CUSTOMER_DATA'


